import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import lang from '@/lang'
import ClientConnectionStatusEnum from '@/enums/client-connection-status.enum'

const ConnectionStateCellRenderer = (props) => {
  const { value: status } = props
  const classes = useStyles()

  const createStatusCircleColor = () => {
    if (status === ClientConnectionStatusEnum.CONNECTED) {
      return classes.green
    } else if (status === ClientConnectionStatusEnum.DISCONNECTED) {
      return classes.red
    } else return classes.blue
  }

  return (
    <div className={classes.container}>
      <div className={clsx(classes.statusCircle, createStatusCircleColor())} />
      <div>{lang.clientList.connectionStatus[status]}</div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  statusCircle: {
    display: 'flex',
    minWidth: 10,
    maxWidth: 10,
    minHeight: 10,
    maxHeight: 10,
    borderRadius: '50%',
    marginRight: 20,
  },
  green: {
    background: theme.green,
  },
  blue: {
    background: theme.blue,
  },
  red: {
    background: theme.error,
  },
  orange: {
    background: theme.orange,
  },
  grey: {
    background: theme.greyStateColor,
  },
}))

ConnectionStateCellRenderer.propTypes = {
  value: PropTypes.string,
}

export default ConnectionStateCellRenderer
